<template>
  <flow-part :id="$options.name" class="no-height last-step">
    <template #heading />
    <template #content>
      <button-icon-right type="cta" label="Klaar om te vergelijken" icon="arrow-right-long-solid"
        @click.native="goToComparer" />
    </template>
  </flow-part>
</template>

<script>
import WizardStepMixin from '../../../../vue-elements/wizard/lib/WizardStepMixin.js';
import Icon from '../../../../vue-elements/icon/Icon.vue';
import LinkIconRight from '../../../../../abstracts/elements/link/icon-right/link-icon-right.vue';
import FlowPart from '../FlowPart.vue';
import ButtonIconRight from '../../../../../abstracts/elements/button/icon-right/button-icon-right.vue';

export default {
  name: 'GoToComparerStep',
  mixins: [WizardStepMixin()],
  components: {
    ButtonIconRight,
    FlowPart,
    LinkIconRight,
    Icon,
  },
  data() {
    return {};
  },
  methods: {
    goToComparer() {
      this.$emit('goToComparer');
    },
  },
};
</script>

<style lang="scss">
@use 'assets/scss/all' as *;

.last-step {
  padding-top: 16px !important;
  padding-bottom: 32px !important;
  border-top: 0 !important;

  .button-element {
    width: 100%;
  }
}
</style>
